import React, { Fragment } from "react";
import { CustomLink } from "../../custom-link";
import { Menu } from "../menu";
import { getOverride, accessCheck } from "../../../utils";
import { SocialFollow } from "../../basic/social-follow/social-follow";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./sidebar.module.css";

class SidebarTemplate extends React.Component {
  updateCloseSidebar = e => {
    e.stopPropagation();

    return this.props.closeSidebar();
  };

  render() {
    let {
      isSidebarVisible,
      menuItems,
      socialLinks,
      languageDirection,
      customCssClasses,
      toggleSidebar,
      closeAll,
      publisherTheme = {},
      headerClass = "",
      pageBuilderConfig = {},
      socialStyle = {}
    } = this.props;
    const enableAccesstype = get(
      pageBuilderConfig,
      ["header", "enableSubscriptionButton"],
      get(publisherTheme, ["enableAccesstype"], false)
    );
    const isSSOEnabled = get(pageBuilderConfig, ["header", "enableSSO"], get(publisherTheme, ["enableSSO"], false));
    const sidebar = {
      header_2: "open-right",
      header_4: "open-right",
      "single-layer-header_2": "open-right",
      "single-layer-header_5": "open-right"
    };
    const getSidebarClass = new Proxy(sidebar, getOverride("open-left"));

    const sidebarOverlay = {
      header_2: "overlay-open-right",
      header_4: "overlay-open-right",
      "single-layer-header_2": "overlay-open-right",
      "single-layer-header_5": "overlay-open-right"
    };
    const getSidebarOverlayClass = new Proxy(sidebarOverlay, getOverride("overlay-open-left"));

    const sidebarOverride = {
      header_2: "override-sidebar-header-2",
      header_4: "override-sidebar-header-4",
      "single-layer-header_2": "override-sidebar-single-header-2"
    };
    const getsidebarOverrideClass = new Proxy(sidebarOverride, getOverride(""));

    return (
      <Fragment>
        <div
          styleName={`overlay ${customCssClasses} ${isSidebarVisible ? "overlay--active" : ""} ${
            getSidebarOverlayClass[get(pageBuilderConfig, ["header", "headerStyle"], publisherTheme["header_theme"])]
          }`}
          onClick={this.closeSidebar}
        />
        <div
          styleName={`sidebar sidebar--visible ${customCssClasses} ${headerClass} ${
            getSidebarClass[get(pageBuilderConfig, ["header", "headerStyle"], publisherTheme["header_theme"])]
          } ${
            getsidebarOverrideClass[get(pageBuilderConfig, ["header", "headerStyle"], publisherTheme["header_theme"])]
          } ${!isSSOEnabled ? "no-login-pos" : ""}`}
        >
          <nav>
            <Menu
              closeAll={closeAll}
              menu={menuItems}
              sidebar
              languageDirection={languageDirection}
              toggleSidebar={toggleSidebar}
              customCssClasses={`sidebar ${headerClass}`}
            />
          </nav>
          <div styleName="cta-wrapper">
            <SocialFollow
              hasBackground={true}
              socialLinks={socialLinks}
              socialStyle={socialStyle}
              customCssClasses="sidebar"
              isSidebar
            />
            {accessCheck(enableAccesstype) && (
              <CustomLink href="/subscription" styleName="btn">
                Subscribe
              </CustomLink>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

SidebarTemplate.propTypes = {
  headerConfig: PropTypes.object,
  menuItems: PropTypes.array,
  socialLinks: PropTypes.object,
  languageDirection: PropTypes.string,
  customCssClasses: PropTypes.string,
  toggleSidebar: PropTypes.func,
  closeAll: PropTypes.func,
  publisherTheme: PropTypes.object,
  closeSidebar: PropTypes.func,
  isSidebarVisible: PropTypes.bool,
  headerClass: PropTypes.string,
  config: PropTypes.object,
  pageBuilderConfig: PropTypes.object,
  socialStyle: PropTypes.object
};

export { SidebarTemplate };
